// product-details.module.ts
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GridModule } from '@frk/eds-components';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { BaseEntryProductComponent } from './base-entry-product-component';
import {
  FundHeaderModule,
  fundHeaderModuleComponentMapping,
} from './fund-header/fund-header.module';
import {
  FundPerformanceModule,
  fundPerformanceModuleComponentMapping,
} from './fund-performance/fund-performance.module';
import {
  OverviewModule,
  overviewModuleComponentMapping,
} from './overview/overview.module';
import {
  PortfolioModule,
  portfolioModuleComponentMapping,
} from './portfolio/portfolio.module';
import {
  pricingDistributionComponentMapping,
  PricingDistributionModule,
} from './pricing-distribution/pricing-distribution.module';
import { FundDetailService } from './services/fund-detail.service';
import { FundOverviewService } from './services/fund-overview.service';
import { FundPerformanceHistoryService } from './services/fund-performance-history.service';
import { FundSummaryService } from './services/fund-summary.service';
import { PricingHistoryService } from './services/pricing-history.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    OverviewModule,
    FundPerformanceModule,
    PricingDistributionModule,
    PortfolioModule,
    FundHeaderModule,
    GridModule,
  ],
  declarations: [BaseEntryProductComponent],
  providers: [
    FundOverviewService,
    FundSummaryService,
    FundDetailService,
    PricingHistoryService,
    FundPerformanceHistoryService,
  ],
})
export class ProductDetailsModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return Object.assign(
      {},
      overviewModuleComponentMapping,
      portfolioModuleComponentMapping,
      fundHeaderModuleComponentMapping,
      fundPerformanceModuleComponentMapping,
      pricingDistributionComponentMapping,
      fundPerformanceModuleComponentMapping
    );
  }
}
